import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef, WrappedValue, Inject } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Subscriber } from "rxjs/Subscriber";
import { Http, Headers, ResponseContentType } from "@angular/http";

import { StaticUrls } from '../models';
import { MyCookieService } from "../services/my-cookie.service";
import { environment } from "environments/environment";

@Pipe({
	name: 'secureUrl',
	pure: false
})
export class SecureUrlPipe implements PipeTransform, OnDestroy 
{
	private _latestValue: any = null;
	private _latestReturnedValue: any = null;
	private _subscription: Subscription = null;
	private _obj: Observable<any> = null;
	private previousUrl: string;
	private _result: BehaviorSubject<any> = new BehaviorSubject('');
	private result: Observable<any> = this._result.asObservable();
	private _internalSubscription: Subscription = null;

	constructor(
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		private _ref: ChangeDetectorRef,
		private sanitizer: DomSanitizer,
		private http: Http
	) { }

	ngOnDestroy(): void {
		if (this._subscription) {
			this._dispose();
		}
	}

	transform(url: string) {
		let obj = this.internalTransform(url);
		return this.asyncTrasnform(obj);
	}

	private internalTransform(url: string): Observable<any> {
		if (!url) {
			return this._result.asObservable();
		}
		if (this.previousUrl !== url) {
			this.previousUrl = url;
			this._internalSubscription = this.getUrl(url).subscribe(m => {
				let sanitized = this.sanitizer.bypassSecurityTrustUrl(m);
				this._result.next(sanitized);
			});
		}
		return this.result;
	}

	private asyncTrasnform(obj: Observable<any>): any {
		if (!this._obj) {
			if (obj) {
				this._subscribe(obj);
			}
			this._latestReturnedValue = this._latestValue;
			return this._latestValue;
		}
		if (obj !== this._obj) {
			this._dispose();
			return this.asyncTrasnform(obj);
		}
		if (this._latestValue === this._latestReturnedValue) {
			return this._latestReturnedValue;
		}
		this._latestReturnedValue = this._latestValue;
		return WrappedValue.wrap(this._latestValue);
	}

	private _subscribe(obj: Observable<any>) {
		var _this = this;
		this._obj = obj;
		this._subscription = obj.subscribe({
			next: function (value) {
				return _this._updateLatestValue(obj, value);
			}, error: (e: any) => { throw e; }
		});
	}

	private _dispose() {
		this._subscription.unsubscribe();
		this._internalSubscription.unsubscribe();
		this._internalSubscription = null;
		this._latestValue = null;
		this._latestReturnedValue = null;
		this._subscription = null;
		this._obj = null;
	}

	private _updateLatestValue(async: any, value: Object) {
		if (async === this._obj) {
			this._latestValue = value;
			this._ref.markForCheck();
		}
	}

	getUrl(url: string): Observable<any> {
		return new Observable((observer: Subscriber<any>) => {
			let objectUrl: string = null;
			this.http
				.get(StaticUrls._file + url, { headers: this.getHeaders(), responseType: ResponseContentType.Blob })
				.subscribe(m => {
					objectUrl = URL.createObjectURL(m.blob());
					observer.next(objectUrl);
			});
			return () => {
				if (objectUrl) {
					URL.revokeObjectURL(objectUrl);
					objectUrl = null;
				}
			};
		});
	}

	getHeaders(): Headers {
		let headers = new Headers();
		if(this.myCookieService.token){
			let token = localStorage.getItem(environment.tokenName);
			if (token) { headers.set(environment.headerName, token); }
		}
		return headers;
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/pipes/secureUrl.pipe.ts